import { useState } from "react";
import { handleError } from "../model/handleError";
import EsamiUtentiService from "../services/EsamiUtentiService/EsamiUtentiService";
import { alertService } from "../services/AlertService";

const useEsamiUtenti = () => {
  const [loadingState, setLoadingState] = useState({
    getEsamiUtentiByIdEsame: false,
    isLoadingEsameUtenteCreating: false,
    isLoadingEsameUtentePrenotazione: false,
    isLoadingEsameUtenteDelete: false,
    isLoadingEsameUtenteUpdate: false,
    isLoadingEsameUtentiResultsUpdate: false,
    isLoadingEsamiUtentiByIdClasseUtente: false,
    isLoadingEnterJoinroomCorsista: false,
    isLoadingEnterJoinroomAdmin: false,
  });

  const [modalState, setModalState] = useState({
    showModalInfoEsameUtente: false,
    showModalCreateEsameUtente: false,
    showModalDeleteEsameUtente: false,
    showModalUpdateEsameUtente: false,
  });

  const getEsamiUtentiByIdEsame = async (esameId) => {
    setLoadingState({ ...loadingState, getEsamiUtentiByIdEsame: true });
    try {
      let response = await EsamiUtentiService.getEsamiUtentiByIdEsame(esameId);
      return response;
    } catch (error) {
      alertService.error(
        "Si è verificato un errore nel tentativo di visualizzare gli utenti dell'esame",
        { autoClose: true }
      );
    } finally {
      setLoadingState({ ...loadingState, getEsamiUtentiByIdEsame: false });
    }
  };

  const getEsamiUtentiByIdClasseUtente = async (idClasseUtente) => {
    setLoadingState({ ...loadingState, isLoadingEsamiUtentiByIdClasseUtente: true });
    try {
      let response = await EsamiUtentiService.getEsamiUtentiByIdClasseUtente(idClasseUtente);
      return response;
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState({ ...loadingState, isLoadingEsamiUtentiByIdClasseUtente: false });
    }
  }

  const updateEsameUtentiResults = async (data) => {
    setLoadingState({ ...loadingState, isLoadingEsameUtentiResultsUpdate: true });
    try {
      let response = await EsamiUtentiService.updateEsameUtentiResults(data);
      return response;
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState({ ...loadingState, isLoadingEsameUtentiResultsUpdate: false });
    }
  } 

  const createEsameUtente = async (data) => {
    setLoadingState({ ...loadingState, isLoadingEsameUtenteCreating: true });
    try {
      let response = await EsamiUtentiService.createEsameUtente(data);
      alertService.success("Utente aggiunto all'esame con successo", { autoClose: true });
      setModalState({ ...modalState, showModalCreateEsameUtente: false });
      return response;
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState({ ...loadingState, isLoadingEsameUtenteCreating: false });
    }
  };

  const prenotaEsameCorsoSincrono = async (data) => {
    setLoadingState((prev) => ({ ...prev, isLoadingEsameUtentePrenotazione: true }));
    try {
      let response = await EsamiUtentiService.prenotaEsameCorsoSincrono(data);
      alertService.success("Prenotazione effettuata con successo", { autoClose: true });
      return response;
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState((prev) => ({ ...prev, isLoadingEsameUtentePrenotazione: false }));
    }
  };

  const prenotaEsameCorsoAsincrono = async (data) => {
    setLoadingState((prev) => ({ ...prev, isLoadingEsameUtentePrenotazione: true }));
    try {
      let response = await EsamiUtentiService.prenotaEsameCorsoAsincrono(data);
      alertService.success("Prenotazione effettuata con successo", { autoClose: true });
      return response;
    } catch (error) {
      handleError(error, {
        RESOURCE_ALREADY_EXISTS: "Questo esame è già stato prenotato"
      });
    } finally {
      setLoadingState((prev) => ({ ...prev, isLoadingEsameUtentePrenotazione: false }));
    }
  }

  const deleteEsameUtente = async (id) => {
    try {
      setLoadingState({ ...loadingState, isLoadingEsameUtenteDelete: true });
      await EsamiUtentiService.deleteEsameUtente(id);
      // alertService.success("Utente rimosso dall'esame con successo", {
      //   autoClose: true,
      // });
      setModalState({ ...modalState, showModalDeleteEsameUtente: false });
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState({ ...loadingState, isLoadingEsameUtenteDelete: false });
    }
  };

  const updateEsameUtente = async (data) => {
    try {
      setLoadingState({ ...loadingState, isLoadingEsameUtenteUpdate: true });
      let response = await EsamiUtentiService.updateEsameUtente(data);
      alertService.success("Utenti abilitati per l'esame aggiornati con successo", {
        autoClose: true,
      });
      setModalState({ ...modalState, showModalUpdateEsameUtente: false });
      return response;
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState({ ...loadingState, isLoadingEsameUtenteUpdate: false });
    }
  };

  const enterJoinroomCorsista = async (data) => {//NEW
    setLoadingState((prev) => ({ ...prev, isLoadingEnterJoinroomCorsista: true }));
    try {
      let response = await EsamiUtentiService.enterJoinroomCorsista(data);
      //alertService.success("Prenotazione effettuata con successo", { autoClose: true });
      return response;
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState((prev) => ({ ...prev, isLoadingEnterJoinroomCorsista: false }));
    }
  }

  const enterJoinroomAdmin = async (data) => {//NEW
    setLoadingState((prev) => ({ ...prev, isLoadingEnterJoinroomAdmin: true }));
    try {
      let response = await EsamiUtentiService.enterJoinroomAdmin(data);
      //alertService.success("Prenotazione effettuata con successo", { autoClose: true });
      return response;
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState((prev) => ({ ...prev, isLoadingEnterJoinroomAdmin: false }));
    }
  }

  return {
    getEsamiUtentiByIdEsame,
    createEsameUtente,
    deleteEsameUtente,
    updateEsameUtente,
    prenotaEsameCorsoSincrono,
    prenotaEsameCorsoAsincrono,
    enterJoinroomCorsista,
    enterJoinroomAdmin,
    loadingStateEsamiUtenti: loadingState,
    modalStateEsamiUtenti: modalState,
    updateEsameUtentiResults,
    getEsamiUtentiByIdClasseUtente
  };
};

export default useEsamiUtenti;
